/**
 * Thin wrapper that mounts ReportWorkspace inside the evaluation shell.
 * All workspace logic lives in `components/reports/ReportWorkspace.tsx`
 * (ported per C3 / MYD-196).
 */

import { useOutletContext } from 'react-router-dom'
import type { EvaluationOutletContext } from '../Evaluations_ShowCN'
import ReportWorkspace from './reports/ReportWorkspace'

const EvaluationReports = () => {
	const { evalId } = useOutletContext<EvaluationOutletContext>()
	return <ReportWorkspace evalId={evalId} />
}

export default EvaluationReports
